<template>
    <div class="modal-backdrop pt-4">
        <div class="card col-lg-5 col-md-8 col-11 p-0 mx-auto">
            <div class="" v-if="pageloader">
              <img src="../assets/loading_gif1.gif" class="pageloader" alt="loading">
            </div>
            <div class="modal-content border-0" v-else>
                <div class="modal-header borderbottom p-4">
                    <div class="d-lg-flex">
                      <h5 class="modal-title font16-bold ml-2" id="exampleModalLabel">Job Details</h5>
                    </div>   
                    <button type="button" class="close" @click="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body bodymodal14">
                    <div class="col-12 backgroundcolor1 borderbottom p-2 pb-4 d-flex">
                      <div class="col-2">
                        <img :src="JobObject.companyProfileLink" class="img-fluid rounded-circle" alt="companylogo">
                      </div>
                      <div class="col-10 pt-2">
                        <div class="d-flex justify-content-between">
                          <span class="fontsize20 black proximanova stylebold">{{JobObject.jobTitle}}</span>
                          <!-- <img src="../assets/horizontal_menu_icon.svg" width="20px" class="img-fluid mr-5" alt=""> -->
                          <div>
                                <img src="../assets/sharearrow.png" id="sharemenu" width="22px" height="22px" v-popover:sharemenu class="img-fluid close mr-2 pointer more_optionhoriz" alt="moremenu">
                                <popover name="sharemenu" class="moremenuforviewjob">
                                    <div class="p-2">
                                        <div class="d-flex p-1 justify-content-between">
                                            <span class="fontsize12 proximanova-bold black">More Actions</span>
                                            <div class="">
                                                <img src="../assets/Close1.svg" alt="close" class="img-fluid close pointer" width="17px" height="17px" @click="closeMoreActions()">
                                            </div>
                                        </div>
                                        <!-- <div class="d-flex p-1 action pointer" id="onclickshare">
                                            <img src="../assets/Hide.svg" alt="hide" class="img-fluid pl-1 pr-1 ">
                                            <span class="pt-2 pl-2 d-flex flex-column">
                                                <div class="fontsize14 black80 proximanova">Report Job</div>
                                            </span>
                                        </div>
                                        <div class="d-flex p-1 action pointer">
                                            <img src="../assets/Report.svg" alt="report" class="img-fluid pl-1 pr-1">
                                            <span class="pt-2 pl-2 d-flex flex-column">
                                                <div class="fontsize14 black80 proximanova">Hide Job</div>
                                            </span>
                                        </div> -->
                                        <div class="d-flex p-1 action pointer"  @click="shareJob(JobObject)">
                                            <img src="../assets/sharejob.png" alt="report" width="28" height="20" class="my-auto pl-1 pr-1">
                                            <span class="pt-1 pl-2 d-flex flex-column">
                                                <div class="fontsize14 black80 proximanova">Share</div>
                                            </span>
                                        </div>
                                        <div class="d-flex p-1 action pointer"  @click="copyJobLink(JobObject)">
                                            <img src="../assets/hyperlink1.png" alt="report" width="28" height="20" class="my-auto pl-1 pr-1">
                                            <span class="pt-1 pl-2 d-flex flex-column">
                                                <div class="fontsize14 black80 proximanova">Copy link</div>
                                            </span>
                                        </div>
                                    </div>
                                </popover>
                            </div>  
                        </div>
                        <div class="d-flex flex-column mt-1">
                          <span class="fontsize16 black proximanova">{{JobObject.companyName}}</span>
                          <div>
                            <span class="fontsize16 black60 proximanova" v-if="JobObject.industry">{{JobObject.industry}}</span>
                            <span class="fontsize16 black60 proximanova" v-else>Professional Network Services</span>
                            <span class="ml-2 mr-2 black60">|</span>
                            <span class="fontsize16 black60 proximanova">{{JobObject.country}}</span>
                          </div>
                        </div>
                        <div class="d-flex mt-2 justify-content-between">
                          <div class="mt-1">
                            <span class="fontsizemd black stylebold proximanova" v-if="jobDetails.creationD">{{jobDetails.creationD | moment("from", "now", true)}} ago</span>
                            <span class="ml-2 mr-2 black60">|</span>
                            <span class="forgot-password proximanova">{{JobObject.jobApplicantCount}} Applications</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 p-3">
                      <div class="d-flex mb-2">
                        <div class="pl-2 pr-1">
                          <img src="../assets/JobViewHired.svg" alt="hired">
                        </div>
                        <div class="col-4">
                          <span class="fontsizemd black60 proximanova">Employment Type</span>
                        </div>
                        <div class="col-4">
                          <span class="fontsizemd black proximanova" v-if="jobDetails.employeeType">{{jobDetails.employeeType.indexDetailName}}</span>
                          <span class="fontsizemd black proximanova" v-else>-</span>
                        </div>
                      </div>
                      <div class="d-flex mb-2">
                        <div class="pl-2 pr-1">
                          <img src="../assets/JobViewSeniority.svg" alt="seniority">
                        </div>
                        <div class="col-4">
                          <span class="fontsizemd black60 proximanova">Seniority</span>
                        </div>
                        <div class="col-4">
                          <span class="fontsizemd black proximanova" v-if="jobDetails.seniorityType">{{jobDetails.seniorityType.indexDetailName}}</span>
                          <span class="fontsizemd black proximanova" v-else>-</span>
                        </div>
                      </div>
                      <div class="d-flex mb-2">
                        <div class="pl-2 pr-1">
                          <img src="../assets/JobViewAmount.svg" alt="salary">
                        </div>
                        <div class="col-4">
                          <span class="fontsizemd black60 proximanova">Pay Scale</span>
                        </div>
                        <div class="col-4">
                          <span class="fontsizemd black proximanova">{{jobDetails.payScaleFrom}} - {{jobDetails.payScaleTo}}</span>
                        </div>
                      </div>
                      <div class="d-flex mb-2">
                        <div class="pl-2 pr-1">
                          <img src="../assets/JobViewLocation.svg" alt="location">
                        </div>
                        <div class="col-4">
                          <span class="fontsizemd black60 proximanova">Job Location</span>
                        </div>
                        <div class="col-4">
                          <span class="fontsizemd black proximanova">{{jobDetails.city.cityName}}, {{jobDetails.country.countryName}}, {{jobDetails.zipcode}}</span>
                        </div>
                      </div>
                      <div class="horizontalline mt-3"></div>
                    </div>
                    <div class="col-12">
                      <div class="d-flex flex-column pl-3 pr-3 pt-2 pb-1">
                        <span class="fontsize16 stylebold proximanova black mb-2">Job Description</span>
                        <!-- <span class="fontsizemd proximanova black mb-3 lineheight22">{{jobDetails.jobDesc}}</span> -->
                        <quill-editor v-model="jobDetails.jobDesc" :options="editorOption" class="quill1" disabled></quill-editor>
                      </div>
                      <div class="horizontalline mt-1 mb-2" v-if="jobDetails.addedSkillsList.length > 0"></div>
                    </div>
                    <div class="col-12">
                      <div class="d-flex flex-column pl-3 pr-3 pt-2 pb-1">
                        <span class="fontsize16 stylebold proximanova black mb-2">Skills Required</span>
                        <div class="row no-gutters mt-2 ml-0">
                            <div v-if="jobDetails.addedSkillsList.length > 0" class="d-flex flex-wrap mb-3 col" >
                                <div v-for="(skill, index) in jobDetails.addedSkillsList" :key="index" >
                                  <div class="pl-3 pr-3 p-1 mr-3 black80 fontsize12 backgroundcolor2 stylebold borderradius10 proximanova d-flex mt-1">
                                      {{skill.skillName}}
                                  </div>
                                </div>
                            </div>
                        </div>
                      </div>
                      <!-- <div class="horizontalline mt-3 mb-3" v-if="jobDetails.screeningQuestionsList.length > 0"></div> -->
                    </div>
                    <!-- <div class="col-12">
                      <div class="d-flex flex-column pl-3 pr-3 pt-2 pb-1">
                        <span class="fontsize16 stylebold proximanova black mb-2">More Details</span>
                        <span class="fontsizemd proximanova black mb-2 lineheight22">Screening Questions.</span>
                        <span class="fontsizemd proximanova black60 mb-2 lineheight22">Any screening questions added will appear once you click Apply.</span>
                        <div class="row no-gutters mt-1 mb-2 ml-0">
                            <div v-if="jobDetails.screeningQuestionsList.length > 0" class="d-flex flex-wrap mb-3 col" >
                                <div v-for="(qsn, index) in jobDetails.screeningQuestionsList" :key="index" >
                                  <div class="pl-3 pr-3 p-1 mr-3 black80 fontsize12 backgroundcolor2 stylebold borderradius10 proximanova d-flex mt-1">
                                      {{qsn.question}}
                                  </div>
                                </div>
                            </div>
                        </div>
                      </div>
                    </div> -->
                    <div class="horizontalline mt-1 mb-2" v-if="jobDetails.companydetails"></div>
                    <div class="col-12" v-if="jobDetails.companydetails">
                      <div class="d-flex flex-column pl-3 pr-3 pt-2 pb-3">
                        <span class="fontsize16 stylebold proximanova black mb-2">About the Company</span>
                        <div class="d-flex mt-2">
                          <div class="col-2 pl-0">
                            <img v-if="jobDetails.companydetails.companyLogoLink" :src="jobDetails.companydetails.companyLogoLink" oncontextmenu="return false" alt="companylogo" class="profile-border img-fluid rounded-circle loadingBgImg_job jobImg" id="profImage">
                            <img v-else src="../assets/Profile_placehlder.svg" oncontextmenu="return false" class="profile-border img-fluid rounded-circle jobImg" alt="companylogo" id="profImage">
                          </div>
                          <div class="d-flex flex-column pl-0 col-10">
                            <div class="d-flex justify-content-between">
                              <span class="font32 proximanova">{{jobDetails.companydetails.companyName}}</span>
                              <button @click="followCompany" :disabled="disablefollowBtn" v-if="followingTest === 'Follow'" class="btn black border fontsize14 proximanova borderradius20 mouseoverbtn1" style="height:35px">{{followingTest}}</button>
                              <button @click="unfollowCompany" :disabled="disablefollowBtn" v-if="followingTest === 'Following'" class="btn black border fontsize14 proximanova borderradius20 mouseoverbtn1" style="height:35px">{{followingTest}}</button>
                            </div>
                            <div class="d-flex">
                              <span class="fontsize16 black60 proximanova " v-if="jobDetails.companydetails.industry">{{jobDetails.companydetails.industry}}</span>
                              <span v-else> - </span>
                              <span class="ml-2 mr-2 black60">|</span>
                              <span class="fontsize16 black60 proximanova" v-if="jobDetails.companydetails.country">{{jobDetails.country.countryName}}</span>
                              <span v-else> - </span>
                            </div>
                          </div>
                        </div>
                        <div class="d-flex">
                          <div class="col-2"></div>
                          <div class="col-10">
                            <span class="fontsizemd proximanova black">{{jobDetails.companydetails.description}}</span>
                          </div>
                        </div>
                        <div class="d-flex">
                          <div class="col-2"></div>
                            <div class="col-10">
                              <div class="row ">     
                                <div class="mt-2 count">       
                                  <div class="row m-0">       
                                    <div class="col-3 mr-3 pl-0">
                                      <label class="font14bold proximanova-semibold">Followers</label>
                                      <label class="font14bold proximanova-semibold">{{followersCount}}</label>
                                    </div>
                                    <div class="col-3 ml-3">
                                      <label class="font14bold proximanova-semibold">Following</label>
                                      <label class="font14bold proximanova-semibold">{{followingCount}}</label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="jobDetails.companyIntroVideoDetails">
                      <div class="videocardbody mt-2">
                        <div class="col-12 jobvideocard">                         
                          <div >                         
                            <video height="320" oncontextmenu="return false" @ended="onenddisplayreplayIcon()" @waiting="displayLoadingLogo()" @canplay="stopLoadingLogo()" controlsList="nodownload"  id="companyIntroVideo" >
                              <source :src="jobDetails.companyIntroVideoDetails.videoLink" id="introvideosrctag">
                            </video>
                          </div>  
                          <div class="card-img-overlay p-0"> 
                            <div class="row no-gutters mb-3 ml-0 mr-0 pb-3 companyvid_overlay1">
                              <div class="p-3 black_overlay_height ml-3 d-flex flex-column"></div>
                            </div>
                            <div class="mt-3 mx-auto">
                              <img src="../assets/play_video.svg" v-if="playIntroVideo" class="playpausevideobtn" alt="playvideo" @click="playPauseCompanyVideo()">
                              <div class="replaybtn shadow" title="replay video" id="viewjob_playvideobtn" v-if="!playIntroVideo && replayIntroVideo">
                                  <img src="../assets/replayVideo.png" class="replayicon mx-auto" alt="replayvideo" @click="replayVideo()">
                              </div>
                              <div class="replaybtn1 shadow playpausevideobtn" title="replay video" id="viewjob_playvideobtn" v-if="!playIntroVideo && loadingIntroVideo">
                                  <img src="../assets/video_loading.gif" class="replayicon1 mx-auto" alt="loadingvideo">
                              </div>
                              <img src="../assets/Pausevideo.svg" class="playpausevideobtn pausebtn" v-if="!playIntroVideo && !replayIntroVideo && !loadingIntroVideo" alt="pausevideo" @click="playPauseCompanyVideo()">
                            </div>
                            <div class="bottom">
                              <div class="companyvid_overlay2">
                                <div class="p-3 black_overlay_height ml-3 d-flex flex-column"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                        <!-- <video height="320" oncontextmenu="return false" :src="jobDetails.companyIntroVideoDetails.videoLink" controlsList="nodownload"  id="introVideo" > </video> -->
                    </div>  
                    <div class="col-12 mb-4" v-if="jobDetails.companydetails">
                      <label class="fontsize14 black stylebold proximanova ml-3">More Details</label>
                      <div class="d-flex mb-2">
                        <div class="col-5 col-lg-3">
                          <span class="fontsizemd black60 proximanova">Contact Number</span>
                        </div>
                        <div class="col-6 col-lg-4">
                          <span class="fontsizemd black proximanova" v-if="jobDetails.companydetails.contactNumber">
                            {{jobDetails.companydetails.contactNumber}}
                          </span>
                          <span class="fontsize14 black proximanova" v-else>--</span>
                        </div>
                      </div>
                      <div class="d-flex mb-2">
                        <div class="col-5 col-lg-3">
                          <span class="fontsizemd black60 proximanova">Company Size</span>
                        </div>
                        <div class="col-6 col-lg-4">
                          <span class="fontsizemd black proximanova" v-if="jobDetails.companydetails.companySize">
                            {{jobDetails.companydetails.companySize}}
                          </span>
                          <span class="fontsize14 black proximanova" v-else>--</span>
                        </div>
                      </div>
                      <div class="d-flex mb-2">
                        <div class="col-5 col-lg-3">
                          <span class="fontsizemd black60 proximanova">Industry</span>
                        </div>
                        <div class="col-6 col-lg-4">
                          <span class="fontsizemd black proximanova" v-if="jobDetails.companydetails.industry">
                            {{jobDetails.companydetails.industry}}
                          </span>
                          <span class="fontsize14 black proximanova" v-else>--</span>
                        </div>
                      </div>
                      <div class="d-flex mb-2">
                        <div class="col-5 col-lg-3">
                          <span class="fontsizemd black60 proximanova">Founded</span>
                        </div>
                        <div class="col-6 col-lg-4">
                          <span class="fontsizemd black proximanova" v-if="jobDetails.companydetails.founded">{{jobDetails.companydetails.founded}}</span>
                          <span class="fontsize14 black proximanova" v-else>--</span>
                        </div>
                      </div>
                      <div class="d-flex mb-2">
                        <div class="col-5 col-lg-3">
                          <span class="fontsizemd black60 proximanova">Specialities</span>
                        </div>
                        <div class="col-6 col-lg-4">
                          <span class="fontsizemd black proximanova" v-if="jobDetails.companydetails.specialities">
                            {{jobDetails.companydetails.specialities}}
                          </span>
                          <span class="fontsize14 black proximanova" v-else>--</span>
                        </div>
                      </div>
                      <div class="d-flex mb-2">
                        <div class="col-5 col-lg-3">
                          <span class="fontsizemd black60 proximanova">Type</span>
                        </div>
                        <div class="col-6 col-lg-4">
                          <span class="fontsizemd black proximanova" v-if="jobDetails.companydetails.type">
                            {{jobDetails.companydetails.type}}
                          </span>
                          <span class="fontsize14 black proximanova" v-else>--</span>
                        </div>
                      </div>
                      <div class="d-flex mb-2">
                        <div class="col-5 col-lg-3">
                          <span class="fontsizemd black60 proximanova">Location</span>
                        </div>
                        <div class="col-lg-4 col-md-4 col-6 d-flex">                         
                          <span class="fontsize14 black proximanova" v-if="jobDetails.companydetails.city">{{jobDetails.companydetails.city.cityName}}, </span>
                          <span class="fontsize14 black proximanova" v-if="jobDetails.companydetails.state">{{jobDetails.companydetails.state.stateName}}, </span>
                          <span class="fontsize14 black proximanova" v-if="jobDetails.companydetails.country">{{jobDetails.companydetails.country.countryName}}</span>
                        </div>
                      </div>
                      <div class="horizontalline mb-2 mt-3"></div>
                      <div class="d-flex">
                        <div class="mt-1 mb-1 ml-3 mr-auto">
                          <label class="fontsize14 black60 stylebold proximanova">Social Media</label>
                        </div>
                      </div>
                      <div class="mb-2">
                        <div class="col-12 d-flex pl-0">
                          <span class="fontsize14 black60 proximanova col-lg-4 col-6">Twitter URL</span>
                          <a class="fontsize14 blue proximanova" v-if="jobDetails.companydetails.twitterURL" :href="jobDetails.companydetails.twitterURL" target="_blank">
                              <img src="../assets/twitter.svg" class="img-fluid" alt="twitter">
                          </a>
                          <span class="fontsize14 black proximanova" v-else>--</span>
                          </div>
                      </div>
                      <div class="mb-2">
                          <div class="col-12 d-flex pl-0">
                          <span class="fontsize14 black60 proximanova col-lg-4 col-6">Linked in URL</span>
                          <a class="fontsize14 blue proximanova" v-if="jobDetails.companydetails.linkedInURL" target="_blank" :href="jobDetails.companydetails.linkedInURL">
                              <img src="../assets/linkedin.svg" class="img-fluid" alt="linkedin">
                          </a>
                          <span class="fontsize14 black proximanova" v-else>--</span>
                          </div>
                      </div>
                      <div class="mb-2">
                          <div class="col-12 d-flex pl-0">
                          <span class="fontsize14 black60 proximanova col-lg-4 col-6">Youtube URL</span>
                          <a class="fontsize14 blue proximanova" v-if="jobDetails.companydetails.youtubeURL" target="_blank" :href="jobDetails.companydetails.youtubeURL">
                              <img src="../assets/youtube.svg" class="img-fluid" alt="youtube">
                          </a>
                          <span class="fontsize14 black proximanova" v-else>--</span>
                          </div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
        <APIerrorModal v-if="displayAPIerrorModal" @closeAPIerrorModal="closeAPIerrorModal"></APIerrorModal> 
    </div>  
</template>

<script>
import httpuserprofile from "@/js/http-userprofile.js";
import APIerrorModal from './APIerrorpopup.vue'
import wndata from '@/js/wn_data.json'
import commonUtils from '@/js/common-utils.js'
import sessionUtils from '@/js/session-util.js'
export default{
    components: {
      APIerrorModal
    },
   data() {
    return{
      pageloader : true,
      currentUserProfileId : null,
      playIntroVideo : true,
      replayIntroVideo : false,
      loadingIntroVideo : false,
      companyDetails : {},
      jobDetails : null,
      followersCount : 0,
      followingCount : 0,
      followingTest : 'Follow',
      disablefollowBtn : false,
      selectedEmployemntTypeName : null,
      selectedSeniorityTypeName : null,
      editorOption: {
        theme: 'bubble'
      },
      displayAPIerrorModal : false,
    }
  },
  props : [
        'JobObject'
    ],
  methods:{
    closeAPIerrorModal(){
      this.displayAPIerrorModal = false;
    },
    close() {
      this.$emit('closeJobDetailsModal', "cancel" );
    },
    saveJobAsaDraft(){
      console.log("save as a draft : ", this.JobObject)
    },
    //this will invoke after click on close button on more actions menu
    closeMoreActions : function(){
      document.getElementById('sharemenu').click()
    },
    shareJob : function(jobObj){
      commonUtils.shareJob(jobObj)
    },
    copyJobLink(jobObj) {
      commonUtils.copyJobLink(jobObj)
    },
    //fetch selected  job details
    getJobDetails(){
      httpuserprofile.get('/userprofile/getjobDetailsById?jobId='+this.JobObject.jobId+'&userprofileid='+this.currentUserProfileId)
      .then((response) => {
          this.pageloader = false;
          console.log(response)
          this.jobDetails = response.data;
          if(this.jobDetails){
            this.fetchFollowFlag()
            this.fetchCompanyFollowCounts()
          }
          // this.getEmploymentTypesList()
          // this.getSeniorityList()
      }).catch((e) => {
          console.log(e.response)
          this.pageloader = false;
      })
    },
    // fetching the follow relation between loggedin user and the company
    fetchFollowFlag(){
      httpuserprofile.get("/userprofile/getUsertoCompanyFollowFlag?profileId="+this.currentUserProfileId+'&companyProfileId='+this.jobDetails.companyProfileId)
      .then((response) => {
        console.log("company follow flag : ", response)
        let followflag = response.data[0].followingFlag;
        if(followflag == 'Y'){
          this.followingTest =  'Following'; 
        }else if(followflag == 'N'){
          this.followingTest =  'Follow'; 
        }
      })
    },
    //fetching the counts of posted videos, followers and following users count for the selected company
    fetchCompanyFollowCounts(){
      httpuserprofile.get("/userprofile/getCompanyFollowAndFollowingCount?companyProfileId="+this.jobDetails.companyProfileId)
      .then((response) => {
        console.log("counts of the company : ", response);
        this.followersCount = response.data.followerCount;
        this.followingCount = response.data.followingCount;
      })
    },
    //follow company
    followCompany() {
      console.log("follow company")
      this.disablefollowBtn = true;
      httpuserprofile.post("/userprofile/saveUserToCompanyFollowing?UserProfileId="+this.currentUserProfileId+"&CompanyProfileId="+this.jobDetails.companyProfileId)
      .then(response => {
        console.log("user to company follow : ", response)
        // after successfully saved get followers list of the company to update the data  
        this.followingTest =  'Following'; 
        this.followingCount = this.followingCount + 1;
        this.disablefollowBtn = false;
      }).catch((e) => {
        console.log(e)
        this.disablefollowBtn = false;
        this.displayAPIerrorModal = true;
      }); 
    },
    //unfollow company
    unfollowCompany() {
      console.log("unfollow company")
      this.disablefollowBtn = true;
      httpuserprofile.delete("/userprofile/UserToCompanyunfollow?UserProfileId="+this.currentUserProfileId+"&CompanyProfileId="+this.jobDetails.companyProfileId)
      .then(response => {
        console.log("user to company unfollow : ", response)
        // after successfully saved get followers list of the company to update the data  
        this.followingTest =  'Follow'; 
        this.followingCount = this.followingCount - 1;
        this.disablefollowBtn = false;
      }).catch((e) => {
        console.log(e)
        this.disablefollowBtn = false;
        this.displayAPIerrorModal = true;
      });
    },
    // this will invoke aftre click on play/pause icons on company intro video
    playPauseCompanyVideo() {
      this.playIntroVideo = !this.playIntroVideo;
      var video = document.getElementById("companyIntroVideo")
      if(this.playIntroVideo){
        video.pause()
      }else{
       video.play()
      }
    },
    onenddisplayreplayIcon() {
            this.replayIntroVideo = true;
            this.loadingIntroVideo = false;
        },
        displayLoadingLogo() {
            this.loadingIntroVideo = true;
        },
        stopLoadingLogo() {
            this.loadingIntroVideo = false;
        },
        replayVideo() {
            this.replayIntroVideo = false;
            this.loadingIntroVideo = false;
            this.playIntroVideo = false;
            this.playPauseCompanyVideo()
        },
    // get employmment type data based on emploment Id
    getEmploymentTypesList(){
      httpjob.get('/postjob/getListOfIndexDetails?indexcode=2')
      .then((response) => {
        let list = response.data
        console.log(list)
        for(var i =0; i < list.length; i++){
          if(this.jobDetails.employmentTypeId === list[i].id) {
            console.log("into employ")
            this.selectedEmployemntTypeName = list[i].indexDetailName
          }
        }
      }).catch((e) => {
        console.log(e)
      })
    },
    //fetch seniority types list
    getSeniorityList(){
      httpjob.get('/postjob/getListOfIndexDetails?indexcode=17')
      .then((response) => {
        let list = response.data
        console.log(list)
        for(var i =0; i < list.length; i++){
          if(this.jobDetails.seniorityId === list[i].id) {
            console.log("into seniority")
            this.selectedSeniorityTypeName = list[i].indexDetailName
          }
        }
      }).catch((e) => {
        console.log(e)
      })
    },
  },
   mounted() {
    console.log("jobobejct : ", this.JobObject)
    this.currentUserProfileId = sessionUtils.getUserProfileId();
    this.getJobDetails()
  },

}

</script>

<style>
@import '../css/modal.css';
</style>